import { IconButton, useTheme } from "@mui/material";
import { Check } from "lucide-react";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";

interface TaskCompletionCheckboxProps {
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
  size?: number;
  isLoading?: boolean;
}

const TaskCompletionCheckbox = ({
  checked,
  onChange,
  disabled = false,
  size = 20,
  isLoading = false,
}: TaskCompletionCheckboxProps) => {
  const theme = useTheme();

  return (
    <IconButton
      onClick={(e) => {
        e.stopPropagation();
        onChange();
      }}
      disabled={disabled || isLoading}
      sx={{
        backgroundColor: checked
          ? nawyTheme.nawy.colors.semantic.layer.accent
          : "transparent",
        borderRadius: "50%",
        width: size,
        height: size,
        minWidth: size,
        padding: 0,
        alignSelf: "flex-start",
        transition: "all 0.2s ease-in-out",
        border: `2px solid ${ checked ? nawyTheme.nawy.colors.semantic.layer.accent : theme.nawy.colors.semantic.border.primary}`,
        "&:hover": {
          backgroundColor: checked
            ? theme.nawy.colors.semantic.layer.accent
            : theme.nawy.colors.semantic.indicator.greyLight,
          opacity: 0.9,
        },
        "&:active": { 
          transform: "scale(0.95)" 
        },
        "&.Mui-disabled": {
          backgroundColor: checked
            ? nawyTheme.nawy.colors.semantic.layer.accent
            : "transparent",
          opacity: 1,
        },
      }}
    >
      {checked && (
        <Check
          size={size * 0.7}
          color={nawyTheme.nawy.colors.primitives.white[100]}
        />
      )}
    </IconButton>
  );
};

export default TaskCompletionCheckbox;

